"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var wove_1 = require("../core/wove");
var MethodPrecondition = (function () {
    function MethodPrecondition(selector) {
        this.selector = selector;
        // Automatically weave classes
        var classes = selector.classes || [];
        for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
            var c = classes_1[_i];
            wove_1.weave(c);
        }
    }
    MethodPrecondition.prototype.assert = function (_a) {
        var classInstance = _a.classInstance, methodName = _a.methodName;
        var s = this.selector;
        var className = classInstance.name;
        var matchAnyMethod = function (methods, target, methodName) {
            var keys = Object.getOwnPropertyNames(target.prototype);
            return methods.some(function (f) {
                return target.prototype[methodName] === f;
            });
        };
        var matchClass = (!s.classNamePattern && !s.classes) ||
            (s.classNamePattern && s.classNamePattern.test(className)) ||
            (s.classes && s.classes.some(function (c) { return c === classInstance; }));
        var matchMember = (!s.methodNamePattern && !s.methods) ||
            (s.methodNamePattern && s.methodNamePattern.test(methodName)) ||
            (s.methods && matchAnyMethod(s.methods, classInstance, methodName));
        return matchClass && matchMember;
    };
    return MethodPrecondition;
}());
exports.MethodPrecondition = MethodPrecondition;
var MemberPrecondition = (function () {
    function MemberPrecondition(selector) {
        this.selector = selector;
    }
    MemberPrecondition.prototype.assert = function (_a) {
        var className = _a.className, fieldName = _a.fieldName;
        return this.selector.classNamePattern.test(className) &&
            this.selector.fieldNamePattern.test(fieldName);
    };
    return MemberPrecondition;
}());
exports.MemberPrecondition = MemberPrecondition;
